export class LocalSetting {
  constructor(
    readonly name: string,
    readonly status: string,
  ) {}
}
